/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateReferralRecipientConfigRequest
 */
export interface CreateReferralRecipientConfigRequest {
    /**
     * 
     * @type {number}
     * @memberof CreateReferralRecipientConfigRequest
     */
    sender_facility_id: number;
    /**
     * Omit to create an "other" recipient (not backed by the provider directory) — display_name and email become required in that case.
     * @type {string}
     * @memberof CreateReferralRecipientConfigRequest
     */
    provider_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReferralRecipientConfigRequest
     */
    display_name?: string;
    /**
     * Required unless provider_id resolves to an internal (ExaCare) provider, in which case it may be omitted and resolved from contact_id instead.
     * @type {string}
     * @memberof CreateReferralRecipientConfigRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReferralRecipientConfigRequest
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReferralRecipientConfigRequest
     */
    notes?: string;
    /**
     * Provider directory contact to resolve this recipient's email from at send time. Only applicable when provider_id resolves to an internal (ExaCare) provider; the contact must be contact_type 'inbound' for that provider.
     * @type {string}
     * @memberof CreateReferralRecipientConfigRequest
     */
    contact_id?: string;
    /**
     * Fax number to deliver referrals to via eFax, in addition to the required email address.
     * @type {string}
     * @memberof CreateReferralRecipientConfigRequest
     */
    fax?: string;
}

/**
 * Check if a given object implements the CreateReferralRecipientConfigRequest interface.
 */
export function instanceOfCreateReferralRecipientConfigRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "sender_facility_id" in value;

    return isInstance;
}

export function CreateReferralRecipientConfigRequestFromJSON(json: any): CreateReferralRecipientConfigRequest {
    return CreateReferralRecipientConfigRequestFromJSONTyped(json, false);
}

export function CreateReferralRecipientConfigRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateReferralRecipientConfigRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sender_facility_id': json['sender_facility_id'],
        'provider_id': !exists(json, 'provider_id') ? undefined : json['provider_id'],
        'display_name': !exists(json, 'display_name') ? undefined : json['display_name'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'contact_id': !exists(json, 'contact_id') ? undefined : json['contact_id'],
        'fax': !exists(json, 'fax') ? undefined : json['fax'],
    };
}

export function CreateReferralRecipientConfigRequestToJSON(value?: CreateReferralRecipientConfigRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sender_facility_id': value.sender_facility_id,
        'provider_id': value.provider_id,
        'display_name': value.display_name,
        'email': value.email,
        'phone': value.phone,
        'notes': value.notes,
        'contact_id': value.contact_id,
        'fax': value.fax,
    };
}

